// 53吃瓜 · 单页首页静态数据（仅用于静态展示）

export interface HotItem {
  no: number;
  title: string;
  zone: string;
  heat: number;
  trend: string;
  flag: 'hot' | 'new' | 'up' | 'flat';
}

export const hotRank: HotItem[] = [
  { no: 1, title: '某头部主播带货翻车事件全程复盘', zone: '直播瓜', heat: 98600, trend: '+128%', flag: 'hot' },
  { no: 2, title: '顶流偶像恋爱瓜线索时间线整理', zone: '绯闻瓜', heat: 91200, trend: '+96%', flag: 'hot' },
  { no: 3, title: '选秀综艺剧本与剪辑争议复盘', zone: '综艺瓜', heat: 84600, trend: '+73%', flag: 'hot' },
  { no: 4, title: '平台限流与账号被封事件梳理', zone: '平台瓜', heat: 77900, trend: '+61%', flag: 'new' },
  { no: 5, title: '品牌解约风波背后的时间线', zone: '商业瓜', heat: 70100, trend: '+48%', flag: 'up' },
  { no: 6, title: '粉丝控评混战完整截图存档', zone: '饭圈瓜', heat: 63200, trend: '+35%', flag: 'up' },
  { no: 7, title: '主播团队分家内幕按时间复盘', zone: '主播瓜', heat: 55400, trend: '+22%', flag: 'flat' },
  { no: 8, title: '机场接机乱象引发讨论合集', zone: '现场瓜', heat: 49300, trend: '+18%', flag: 'flat' },
  { no: 9, title: '舞台表演假唱争议逐帧复盘', zone: '舞台瓜', heat: 42800, trend: '-6%', flag: 'flat' },
  { no: 10, title: '代言物料翻车旧帖补录', zone: '商业瓜', heat: 36100, trend: '-11%', flag: 'flat' },
];

export const tickerItems: string[] = [
  '补录 2026.08.12 主播翻车全程帖',
  '顶流绯闻瓜 最新线索已并入时间线',
  '新增合集：2026 上半年综艺争议',
  '目录老帖页例行复核完成',
  '平台限流旧帖已补高清截图',
  '饭圈控评事件存档已按时间排序',
  '品牌解约线 6 条关键节点更新',
  '老帖复盘索引扩充至 12 个专区',
];

export interface FeaturedCard {
  id: string;
  tag: string;
  zone: string;
  title: string;
  excerpt: string;
  date: string;
  views: string;
  comments: string;
  img: string;
}

export const featuredCards: FeaturedCard[] = [
  {
    id: 'f1',
    tag: '绯闻瓜',
    zone: '绯闻瓜',
    title: '顶流恋爱瓜：从同款到实锤的完整时间线',
    excerpt: '把同款、行程撞档、粉丝考古等一条条线索按时间串起来，补漏别再自己翻楼。',
    date: '2026.09.02',
    views: '286.4k',
    comments: '1.2k',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20press%20crowd%20at%20red%20carpet%20with%20stage%20spotlight%20flares%2C%20candid%20documentary%20photography%2C%20warm%20amber%20tones%2C%20film%20grain%2C%20busy%20atmosphere&width=1120&height=720&seq=gua-card-01&orientation=landscape',
  },
  {
    id: 'f2',
    tag: '塌房复盘',
    zone: '塌房复盘',
    title: '头部主播带货翻车全程复盘合集',
    excerpt: '从预热、喊话到售后反转，把整条翻车链路按时间拆开，补上你可能漏看的中间几环。',
    date: '2026.09.01',
    views: '312.0k',
    comments: '1.8k',
    img: 'https://readdy.ai/api/search-image?query=Dim%20backstage%20room%20with%20empty%20velvet%20chairs%20and%20curtain%20edge%20light%2C%20moody%20editorial%20photography%2C%20warm%20dramatic%20low%20key%20lighting&width=1120&height=720&seq=gua-card-02&orientation=landscape',
  },
  {
    id: 'f3',
    tag: '直播瓜',
    zone: '直播瓜',
    title: '直播间翻车名场面逐帧拆解',
    excerpt: '把直播时的每一句关键台词和画面变化逐帧拆开，还原当时到底发生了什么。',
    date: '2026.08.30',
    views: '198.7k',
    comments: '946',
    img: 'https://readdy.ai/api/search-image?query=Large%20studio%20monitor%20showing%20live%20broadcast%20desk%20with%20glowing%20screen%20and%20comment%20overlay%2C%20tech%20newsroom%20editorial%2C%20warm%20orange%20ambient&width=1120&height=720&seq=gua-card-03&orientation=landscape',
  },
  {
    id: 'f4',
    tag: '商业瓜',
    zone: '商业瓜',
    title: '品牌解约风波：关键时间点全记录',
    excerpt: '商务、声明、二轮发酵，把解约这条线的几个关键节点和官方口径一次理清。',
    date: '2026.08.28',
    views: '154.2k',
    comments: '731',
    img: 'https://readdy.ai/api/search-image?query=Hands%20signing%20a%20contract%20over%20a%20glossy%20desk%20with%20gold%20pen%20and%20seal%2C%20warm%20business%20editorial%2C%20soft%20focus%20background&width=1120&height=720&seq=gua-card-04&orientation=landscape',
  },
  {
    id: 'f5',
    tag: '饭圈瓜',
    zone: '饭圈瓜',
    title: '控评混战：截图与热搜位变化存档',
    excerpt: '把热搜位起伏、控评文案变化和评论区节奏截图归到一起，方便复盘整个节奏。',
    date: '2026.08.26',
    views: '133.6k',
    comments: '628',
    img: 'https://readdy.ai/api/search-image?query=Dense%20concert%20crowd%20holding%20up%20glowing%20phone%20screens%20with%20bokeh%20stage%20lights%2C%20documentary%20editorial%2C%20warm%20colors%2C%20energetic&width=1120&height=720&seq=gua-card-05&orientation=landscape',
  },
  {
    id: 'f6',
    tag: '平台瓜',
    zone: '平台瓜',
    title: '账号被限流事件：规则边界盘点',
    excerpt: '同一时间集中限流是什么原因，整理出平台规则变化的几条可能线索。',
    date: '2026.08.24',
    views: '121.9k',
    comments: '512',
    img: 'https://readdy.ai/api/search-image?query=Modern%20data%20center%20with%20server%20racks%20glowing%20amber%20LED%2C%20tech%20editorial%2C%20warm%20tones%2C%20depth%20of%20field&width=1120&height=720&seq=gua-card-06&orientation=landscape',
  },
  {
    id: 'f7',
    tag: '情感瓜',
    zone: '情感瓜',
    title: '高调官宣与低调删帖的情感线复盘',
    excerpt: '从官宣文案到删帖动作，把这段情感瓜的关键节点和网友讨论角度整理归档。',
    date: '2026.08.22',
    views: '98.3k',
    comments: '467',
    img: 'https://readdy.ai/api/search-image?query=Two%20silhouettes%20in%20conversation%20across%20a%20warm%20window%20light%20with%20soft%20curtain%2C%20cinematic%20editorial%2C%20warm%20amber%20tones&width=1120&height=720&seq=gua-card-07&orientation=landscape',
  },
  {
    id: 'f8',
    tag: '综艺瓜',
    zone: '综艺瓜',
    title: '综艺剧本争议：剪辑冲突点还原',
    excerpt: '把被指"剧本"的几个片段和前后文对照还原，给你补上节目外的视角。',
    date: '2026.08.20',
    views: '112.5k',
    comments: '580',
    img: 'https://readdy.ai/api/search-image?query=City%20skyline%20at%20dusk%20in%20warm%20orange%20gradient%20from%20aerial%20view%2C%20editorial%20photography%2C%20dreamy%20golden%20hour&width=1120&height=720&seq=gua-card-08&orientation=landscape',
  },
];

export interface Collection {
  id: string;
  no: string;
  name: string;
  period: string;
  count: string;
  desc: string;
  tone: string;
}

export const collections: Collection[] = [
  {
    id: 'c1',
    no: '合·01',
    name: '2026 上半年综艺争议',
    period: '2026.01 – 2026.06',
    count: '128 帖',
    desc: '把选秀、真人秀与音乐节目的争议片段与讨论统一归入一档，按期索引。',
    tone: 'from-orange-500/15 to-amber-400/15 text-orange-700 border-orange-200',
  },
  {
    id: 'c2',
    no: '合·02',
    name: '主播行业翻车档案',
    period: '2025.09 起持续补录',
    count: '96 帖',
    desc: '带货翻车、团队分家、违约金纠纷，头部主播大事记集中归档。',
    tone: 'from-rose-500/15 to-orange-400/15 text-rose-700 border-rose-200',
  },
  {
    id: 'c3',
    no: '合·03',
    name: '顶流绯闻时间线大汇总',
    period: '跨年度持续更新',
    count: '203 帖',
    desc: '把同款、行程与粉丝考古的线索串成一条完整时间线，别再一条条去翻。',
    tone: 'from-amber-500/15 to-yellow-400/15 text-amber-700 border-amber-200',
  },
  {
    id: 'c4',
    no: '合·04',
    name: '饭圈控评与热搜位记录',
    period: '2026.04 – 2026.08',
    count: '74 帖',
    desc: '截图、热搜位变化与评论区节奏存档，复盘一场完整的控评战役。',
    tone: 'from-emerald-500/15 to-teal-400/15 text-emerald-700 border-emerald-200',
  },
  {
    id: 'c5',
    no: '合·05',
    name: '商业合作与解约纠纷',
    period: '2026.03 起',
    count: '61 帖',
    desc: '品牌合作、声明反转与解约链条，按关键时间节点逐年归档。',
    tone: 'from-lime-500/15 to-lime-300/15 text-lime-700 border-lime-200',
  },
  {
    id: 'c6',
    no: '合·06',
    name: '现场名场面图鉴',
    period: '全年持续收录',
    count: '85 帖',
    desc: '红毯、机场、舞台与活动现场的名场面截图，配上逐帧说明一起看。',
    tone: 'from-teal-500/15 to-emerald-400/15 text-teal-700 border-teal-200',
  },
];

export interface TimelineBlock {
  year: string;
  label: string;
  items: { no: string; title: string; zone: string; status: '已归档' | '补录中' | '待复核' }[];
}

export const timelineBlocks: TimelineBlock[] = [
  {
    year: '2026',
    label: '近半年 · 焦点期',
    items: [
      { no: '帖#2101', title: '某头部主播"喊话"后反转到和解全过程', zone: '直播瓜', status: '已归档' },
      { no: '帖#2100', title: '顶流偶像恋情线索从同款到同框', zone: '绯闻瓜', status: '补录中' },
      { no: '帖#2098', title: '选秀节目剪辑争议的前三集对比', zone: '综艺瓜', status: '已归档' },
      { no: '帖#2096', title: '品牌解约声明的时间线与口径梳理', zone: '商业瓜', status: '待复核' },
    ],
  },
  {
    year: '2025',
    label: '补漏期 · 大量旧帖',
    items: [
      { no: '帖#1852', title: '主播团队分家内幕的九个关键节点', zone: '主播瓜', status: '已归档' },
      { no: '帖#1841', title: '饭圈控评大战完整截图存档', zone: '饭圈瓜', status: '已归档' },
      { no: '帖#1820', title: '机场接机混乱事件的多视角记录', zone: '现场瓜', status: '补录中' },
    ],
  },
  {
    year: '2024 及更早',
    label: '老帖复盘区',
    items: [
      { no: '帖#1307', title: '经典舞台"假唱"争议逐帧复盘', zone: '舞台瓜', status: '待复核' },
      { no: '帖#1289', title: '年度"塌房"名场面回顾（上）', zone: '塌房复盘', status: '已归档' },
      { no: '帖#1266', title: '早期平台限流事件规则盘点', zone: '平台瓜', status: '已归档' },
    ],
  },
];

export interface TopicZone {
  name: string;
  icon: string;
  desc: string;
  count: string;
}

export const topicZones: TopicZone[] = [
  { name: '绯闻瓜', icon: 'ri-heart-3-line', desc: '恋情、官宣与同款线索', count: '360+' },
  { name: '直播瓜', icon: 'ri-live-line', desc: '直播间与带货翻车现场', count: '420+' },
  { name: '综艺瓜', icon: 'ri-clapperboard-line', desc: '选秀、真人秀与剪辑争议', count: '180+' },
  { name: '商业瓜', icon: 'ri-briefcase-4-line', desc: '品牌合作与解约纠纷', count: '150+' },
  { name: '饭圈瓜', icon: 'ri-team-line', desc: '控评、打投与粉丝混战', count: '240+' },
  { name: '塌房复盘', icon: 'ri-flashlight-line', desc: '人设崩塌的完整时间线', count: '95+' },
  { name: '平台瓜', icon: 'ri-cloud-line', desc: '限流、封号与规则变动', count: '110+' },
  { name: '老帖索引', icon: 'ri-archive-drawer-line', desc: '历史帖目录与补录进度', count: '860+' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '这里的「往期精选」和「合集存档」有什么区别？',
    a: '往期精选是按时间顺序挑出来的重点帖，适合跟着看；合集存档则是按题材（综艺、主播、饭圈等）把散落的帖子归到同一档，想补某一类瓜直接从合集进更快。两者在目录老帖里都能互相跳转。',
  },
  {
    q: '「目录老帖」多久更新一次？',
    a: '站内目录与复盘索引会随新瓜热点滚动补录，补录中的帖会打上状态标签；老帖复盘区每月做一次例行复核，修正失效截图与时间线误差。',
  },
  {
    q: '想补漏之前错过的瓜，应该先看哪一块？',
    a: '建议先看「今日热榜」锁定当下焦点，再到「合集存档」按题材补你关心的那类，最后去「目录老帖」按年份时间线把遗漏帖一次性过一遍，基本不用自己翻楼。',
  },
  {
    q: '页面里的按钮和搜索能直接用吗？',
    a: '当前首页为静态整理向展示，按钮、搜索与合集入口仅作演示，点击后暂不跳转或提交；后续接入真实数据与详情页后会开放完整跳转。',
  },
  {
    q: '本站整理的内容以什么为标准？',
    a: '所有精选、合集与老帖均以"按时间线复盘、方便补漏"为整理目标，收录以事实与截图还原为主，不参与站队或情绪化评论。',
  },
];